export const LOAD_CONFIGURATION = 'CUSTOM_QUOTES/LOAD_CONFIGURATION';
export const LOAD_CONFIGURATION_ERROR = 'CUSTOM_QUOTES/LOAD_CONFIGURATION_ERROR';
export const LOAD_CONFIGURATION_SUCCESS = 'CUSTOM_QUOTES/LOAD_CONFIGURATION_SUCCESS';

export const LOAD_QUOTES = 'CUSTOM_QUOTES/LOAD_QUOTES';
export const LOAD_QUOTES_ERROR = 'CUSTOM_QUOTES/LOAD_QUOTES_ERROR';
export const LOAD_QUOTES_SUCCESS = 'CUSTOM_QUOTES/LOAD_QUOTES_SUCCESS';

export const SET_QUOTE_EDIT = 'CUSTOM_QUOTES/SET_QUOTE_EDIT';
